import { render, staticRenderFns } from "./splist.vue?vue&type=template&id=6250bd77&scoped=true&"
import script from "./splist.vue?vue&type=script&lang=js&"
export * from "./splist.vue?vue&type=script&lang=js&"
import style0 from "./splist.vue?vue&type=style&index=0&id=6250bd77&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6250bd77",
  null
  
)

export default component.exports